import { fromNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableModel, ValuableNode } from '../../models'

import type { SchemaModel } from '../../models'
import type { SchemaUnionNode } from './TypedNode'
import type { TypedNode, TypedSpecific } from '@rehaje/core'

export class SchemaUnionModel extends ValuableModel {
  __r_last_target_node: TypedNode | undefined
  @fromNode()
  @reactive()
  target?: string

  @reactive('computed')
  get targetNode(): TypedNode | undefined {
    const node = this.getTypedNode<SchemaUnionNode>()
    if (node) {
      const schema = node.getTargetSchema(this.target)
      if (this.__r_last_target_node) this.__r_cleanupNode(this.__r_last_target_node)
      this.__r_last_target_node = node.spawn<TypedNode>(
        ['current'],
        schema as TypedSpecific
      )
      return this.__r_last_target_node
    }
  }

  @reactive('untrack')
  __r_cleanupNode(node: TypedNode) {
    node.traverse((child) => {
      if (child instanceof ValuableNode) {
        const model = child.getViewModel<ValuableModel>()
        if (model) {
          model.clearValue()
        }
        return false
      }
    })
    node.dispose()
  }

  override joinChildNamePath(child: SchemaModel) {
    return [...this.namePath, ...child.names]
  }

  override joinChildrenValuePath(child: SchemaModel) {
    if (this.parent) {
      return [...this.parent.valuePath, ...this.names]
    }
    return child.names
  }

  /**
   * 渲染节点
   */
  override render() {
    return super.render(this.targetNode?.render?.())
  }
}

declare global {
  export interface RehajeViewModels {
    'Schema.Union': SchemaUnionModel
  }
}
